export const PERMISSION_OPTIONS = [
  { value: 'manage_users', label: 'Manage Users' },
  { value: 'manage_jobs', label: 'Manage Jobs' },
  { value: 'manage_vendors', label: 'Manage Vendors' },
  { value: 'manage_payments', label: 'Manage Payments' },
  { value: 'manage_settings', label: 'Manage Settings' },
  { value: 'view_analytics', label: 'View Analytics' },
  { value: 'manage_content', label: 'Manage Content' },
  { value: 'manage_support', label: 'Manage Support' }
];

export const ADMIN_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MODERATOR: 'moderator'
};
